import './styles.scss'

import clsx from 'clsx'

import B2becTooltip from '@/components/B2becTooltip'
import B2BecLink from '@/components/B2BLink'

import SubItemList from '../../components/SubItemList'

const emptySubCategories = []

function CategoryItem({
  url = '',
  categoryId = '',
  imgUrl = '',
  imgDescription = '',
  title = '',
  subCategories = emptySubCategories,
}) {
  const categoryItemTitle = (title || '').replace(
    /(.*)([-/])(\S)(.*)/,
    '$1$2 $3$4',
  )

  return (
    <div className="category-item__wrapper">
      <B2BecLink to={url}>
        {/* <div className="category-item__image-wrapper"> */}
        <div
          className={clsx('category-item__image-wrapper', {
            'no-image': !imgUrl,
          })}
        >
          {imgUrl
            ? (
              <img
                alt={imgDescription}
                className="category-item__image"
                src={imgUrl}
              />
            )
            : null}
        </div>
        <h2 className="category-item__title pt-3 pb-3">
          <B2becTooltip content={categoryItemTitle} title={categoryItemTitle} />
        </h2>
      </B2BecLink>
      <SubItemList
        listData={subCategories}
        mainCategoryId={categoryId}
        type="category-overview"
      />
    </div>
  )
}

export default CategoryItem
